<div class="custom-ag-table" *ngIf="rowData">
    <div class="custom-ag-table-inner">
        <ag-grid-angular [ngStyle]="style" class="ag-theme-alpine normal" [rowData]="rowData" [columnDefs]="columnDefs"
            (gridReady)="onGridReady($event)" [domLayout]="domLayout" [gridOptions]="gridOptions"
            [rowSelection]="rowSelection"></ag-grid-angular>
        <div class="page-size-section">
            <select (change)="onPageSizeChanged()" [(ngModel)]="paginationPageSize" class="form-select form-select-sm">
                <option *ngFor="let size of paginationPageSizes">
                    {{size}}
                </option>
            </select>
        </div>
    </div>
</div>